// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bookMagnifyingGlass16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-book-magnifying-glass': IconBookMagnifyingGlass;
    }
}

/**
 * The icon component for the 'bookMagnifyingGlass' icon
 */
export class IconBookMagnifyingGlass extends IconSvg {
    public constructor() {
        super(bookMagnifyingGlass16X16);
    }
}

registerIconSvg('icon-book-magnifying-glass', IconBookMagnifyingGlass);
export const iconBookMagnifyingGlassTag = 'nimble-icon-book-magnifying-glass';
